(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('babel-runtime/regenerator'), require('redux-saga/effects'), require('fn-name'), require('babel-runtime/core-js/object/get-prototype-of'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('babel-runtime/core-js/symbol/iterator'), require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/createClass'), require('@f/create-action'), require('snake-case'), require('babel-runtime/core-js/get-iterator')) :
  typeof define === 'function' && define.amd ? define(['exports', 'babel-runtime/regenerator', 'redux-saga/effects', 'fn-name', 'babel-runtime/core-js/object/get-prototype-of', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'babel-runtime/core-js/symbol/iterator', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/createClass', '@f/create-action', 'snake-case', 'babel-runtime/core-js/get-iterator'], factory) :
  (factory((global.reduxSagaHelpers = global.reduxSagaHelpers || {}),global._regeneratorRuntime,global.reduxSaga_effects,global.getFunctionName,global._Object$getPrototypeOf,global._possibleConstructorReturn,global._inherits,global._Symbol$iterator,global._classCallCheck,global._createClass,global.createAction,global.snakeCase,global._getIterator));
}(this, (function (exports,_regeneratorRuntime,reduxSaga_effects,getFunctionName,_Object$getPrototypeOf,_possibleConstructorReturn,_inherits,_Symbol$iterator,_classCallCheck,_createClass,createAction,snakeCase,_getIterator) { 'use strict';

_regeneratorRuntime = 'default' in _regeneratorRuntime ? _regeneratorRuntime['default'] : _regeneratorRuntime;
getFunctionName = 'default' in getFunctionName ? getFunctionName['default'] : getFunctionName;
_Object$getPrototypeOf = 'default' in _Object$getPrototypeOf ? _Object$getPrototypeOf['default'] : _Object$getPrototypeOf;
_possibleConstructorReturn = 'default' in _possibleConstructorReturn ? _possibleConstructorReturn['default'] : _possibleConstructorReturn;
_inherits = 'default' in _inherits ? _inherits['default'] : _inherits;
_Symbol$iterator = 'default' in _Symbol$iterator ? _Symbol$iterator['default'] : _Symbol$iterator;
_classCallCheck = 'default' in _classCallCheck ? _classCallCheck['default'] : _classCallCheck;
_createClass = 'default' in _createClass ? _createClass['default'] : _createClass;
createAction = 'default' in createAction ? createAction['default'] : createAction;
snakeCase = 'default' in snakeCase ? snakeCase['default'] : snakeCase;
_getIterator = 'default' in _getIterator ? _getIterator['default'] : _getIterator;

function generateWrappedFunctionName(functionWrapper, functionWrapped) {
  var overrideWrapped = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

  var wrappedName = overrideWrapped || getFunctionName(functionWrapped);
  return getFunctionName(functionWrapper) + '(' + wrappedName + ')';
}

function construct(Class) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new (Function.prototype.bind.apply(Class, [null].concat(args)))();
  };
}

var Result = function () {
  function Result(value, error) {
    _classCallCheck(this, Result);

    this.ok = null;
    this.err = null;

    this.ok = value;
    this.err = error;
  }

  _createClass(Result, [{
    key: _Symbol$iterator,
    value: _regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.ok;

            case 2:
              _context.next = 4;
              return this.err;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, value, this);
    })
  }, {
    key: "isOk",
    value: function isOk() {
      return this instanceof Ok;
    }
  }, {
    key: "isErr",
    value: function isErr() {
      return this instanceof Err;
    }
  }]);

  return Result;
}();

Result.Ok = Ok;
Result.Err = Err;
var Ok = function (_Result) {
  _inherits(Ok, _Result);

  function Ok(value) {
    _classCallCheck(this, Ok);

    return _possibleConstructorReturn(this, (Ok.__proto__ || _Object$getPrototypeOf(Ok)).call(this, value, null));
  }

  return Ok;
}(Result);

var Err = function (_Result2) {
  _inherits(Err, _Result2);

  function Err(error) {
    _classCallCheck(this, Err);

    return _possibleConstructorReturn(this, (Err.__proto__ || _Object$getPrototypeOf(Err)).call(this, null, error));
  }

  return Err;
}(Result);

var toOk = construct(Ok);
var toErr = construct(Err);

function toResult(fn) {
  var _marked = [wrapFunctionWithToResult].map(_regeneratorRuntime.mark);

  function wrapFunctionWithToResult() {
    var out,
        _args = arguments;
    return _regeneratorRuntime.wrap(function wrapFunctionWithToResult$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fn.apply(undefined, _args);

          case 3:
            out = _context.sent;

            if (!(out && out.then)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt('return', out.then(toOk, toErr));

          case 8:
            return _context.abrupt('return', toOk(out));

          case 9:
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context['catch'](0);
            return _context.abrupt('return', toErr(_context.t0));

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked[0], this, [[0, 11]]);
  }
  wrapFunctionWithToResult.displayName = generateWrappedFunctionName(wrapFunctionWithToResult, fn);
  return wrapFunctionWithToResult;
}

function createBooleanCallHandler(handleSuccess, handleError) {
  function wrapFunctionWithBooleanCallHandler(fn) {
    var _marked = [booleanCallHandler].map(_regeneratorRuntime.mark);

    function booleanCallHandler() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var result;
      return _regeneratorRuntime.wrap(function booleanCallHandler$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return reduxSaga_effects.call.apply(undefined, [toResult(fn)].concat(args));

            case 2:
              result = _context.sent;

              if (!result.isOk()) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return reduxSaga_effects.call(handleSuccess, result.ok);

            case 6:
              _context.next = 10;
              break;

            case 8:
              _context.next = 10;
              return reduxSaga_effects.call(handleError, result.err);

            case 10:
              return _context.abrupt('return', result);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _marked[0], this);
    }
    booleanCallHandler.displayName = generateWrappedFunctionName(booleanCallHandler, fn);
    return booleanCallHandler;
  }
  return wrapFunctionWithBooleanCallHandler;
}

function match(result) {
  return {
    // NOTE: The keys of toHandles are strings; if we need to match a specific
    //       error name then the error must have a string `name` property.
    as: _regeneratorRuntime.mark(function as() {
      var toHandles = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
      var handler, value, defaultErrorHandler, handlerKey, errorToLookFor, currentErrorName;
      return _regeneratorRuntime.wrap(function as$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!toHandles.Ok || !toHandles.Err)) {
                _context.next = 2;
                break;
              }

              throw new Error('match-as requires Ok and Err to be defined');

            case 2:
              handler = void 0, value = void 0;

              if (!result.isOk()) {
                _context.next = 8;
                break;
              }

              handler = toHandles.Ok;
              value = result.ok;
              _context.next = 21;
              break;

            case 8:
              defaultErrorHandler = toHandles.Err;

              handler = defaultErrorHandler;
              _context.t0 = _regeneratorRuntime.keys(toHandles);

            case 11:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 20;
                break;
              }

              handlerKey = _context.t1.value;

              if (!(handlerKey === 'Ok' || handlerKey === 'Err')) {
                _context.next = 15;
                break;
              }

              return _context.abrupt('continue', 11);

            case 15:
              errorToLookFor = handlerKey;
              currentErrorName = result.err.name;

              if (currentErrorName === errorToLookFor) {
                handler = toHandles[handlerKey];
              }
              _context.next = 11;
              break;

            case 20:
              value = result.err;

            case 21:
              _context.next = 23;
              return handler(value);

            case 23:
              return _context.abrupt('return', _context.sent);

            case 24:
            case 'end':
              return _context.stop();
          }
        }
      }, as, this);
    })
  };
}

function createHandlerCallGenerator(handler) {
  var _marked = [handlerCallGenerator].map(_regeneratorRuntime.mark);

  function handlerCallGenerator(value) {
    return _regeneratorRuntime.wrap(function handlerCallGenerator$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return reduxSaga_effects.call(handler, value);

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked[0], this);
  }
  handlerCallGenerator.displayName = generateWrappedFunctionName(handlerCallGenerator, handler);
  return handlerCallGenerator;
}

function callifyHandles(toHandles) {
  var callifiedHandles = {};
  for (var handleKey in toHandles) {
    callifiedHandles[handleKey] = createHandlerCallGenerator(toHandles[handleKey]);
  }
  return callifiedHandles;
}

function createMatchAsCallHandler() {
  var toHandles = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var callifiedHandles = callifyHandles(toHandles);
  function wrapFunctionWithMatchAsCallHandler(fn) {
    var _marked2 = [matchAsCallHandler].map(_regeneratorRuntime.mark);

    function matchAsCallHandler() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var result;
      return _regeneratorRuntime.wrap(function matchAsCallHandler$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return reduxSaga_effects.call.apply(undefined, [toResult(fn)].concat(args));

            case 2:
              result = _context2.sent;
              _context2.next = 5;
              return match(result).as(callifiedHandles);

            case 5:
              return _context2.abrupt('return', result);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _marked2[0], this);
    }
    matchAsCallHandler.displayName = generateWrappedFunctionName(matchAsCallHandler, fn);
    return matchAsCallHandler;
  }
  return wrapFunctionWithMatchAsCallHandler;
}

function generateDefaultCallName(fn) {
  return snakeCase(getFunctionName(fn)).toUpperCase() || 'CALL';
}

function hasDefaultToString(fn) {
  return typeof fn === 'function' && fn.toString().indexOf('function') !== -1;
}

function toActionPutter(actionCreator) {
  var _marked = [actionPutter].map(_regeneratorRuntime.mark);

  function actionPutter(value) {
    return _regeneratorRuntime.wrap(function actionPutter$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return reduxSaga_effects.put(actionCreator(value));

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked[0], this);
  }
  var overrideWrapped = hasDefaultToString(actionCreator) ? false : '' + actionCreator;
  actionPutter.displayName = generateWrappedFunctionName(actionPutter, actionCreator, overrideWrapped);
  return actionPutter;
}

function createEmitActions(successAction, errorAction) {
  function emitActions(fn) {
    successAction = successAction || createAction(generateDefaultCallName(fn) + '_SUCCESS');
    errorAction = errorAction || createAction(generateDefaultCallName(fn) + '_ERROR');
    var booleanCallHandler = createBooleanCallHandler(toActionPutter(successAction), toActionPutter(errorAction));
    return booleanCallHandler(fn);
  }
  return emitActions;
}

var emitActions = createEmitActions();

function waterfall() {
  var _marked = [flow].map(_regeneratorRuntime.mark);

  var fns = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

  function flow() {
    var previousResult, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, fn;

    return _regeneratorRuntime.wrap(function flow$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            previousResult = void 0;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 4;
            _iterator = _getIterator(fns);

          case 6:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 20;
              break;
            }

            fn = _step.value;

            if (!previousResult) {
              _context.next = 14;
              break;
            }

            _context.next = 11;
            return fn(previousResult);

          case 11:
            previousResult = _context.sent;
            _context.next = 17;
            break;

          case 14:
            _context.next = 16;
            return fn();

          case 16:
            previousResult = _context.sent;

          case 17:
            _iteratorNormalCompletion = true;
            _context.next = 6;
            break;

          case 20:
            _context.next = 26;
            break;

          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 26:
            _context.prev = 26;
            _context.prev = 27;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 29:
            _context.prev = 29;

            if (!_didIteratorError) {
              _context.next = 32;
              break;
            }

            throw _iteratorError;

          case 32:
            return _context.finish(29);

          case 33:
            return _context.finish(26);

          case 34:
            return _context.abrupt("return", previousResult);

          case 35:
          case "end":
            return _context.stop();
        }
      }
    }, _marked[0], this, [[4, 22, 26, 34], [27,, 29, 33]]);
  }

  return flow;
}

exports['default'] = emitActions;
exports.createBooleanCallHandler = createBooleanCallHandler;
exports.createMatchAsCallHandler = createMatchAsCallHandler;
exports.toActionPutter = toActionPutter;
exports.createEmitActions = createEmitActions;
exports.emitActions = emitActions;
exports.toResult = toResult;
exports.Result = Result;
exports.Ok = Ok;
exports.Err = Err;
exports.match = match;
exports.waterfall = waterfall;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.js.map
